import React from "react";
import "./comingsoon.css";

const Comingsoon = () => {
  return (
    <div className="commingsoon">
      <div className="bg-text">
        <h1>Coming Soon...</h1>
        <p className="paraph">Currently implementing the page.</p>
      </div>
    </div>
  );
};

export default Comingsoon;
